import { Link } from "react-router-dom";

import { analytics } from "@/analytics";

export default function NotFound() {
  return (
    <main className="p-8">
      <h1 className="text-2xl font-bold text-lf-blue-dark">
        404 — Page Not Found
      </h1>
      <Link
        to="/"
        onClick={() =>
          analytics.track("Navigation Clicked", {
            item: "Back to the dashboard",
            destination: "/",
            location: "not_found",
          })
        }
        className="inline-block pt-4 text-lf-blue-light underline"
      >
        Back to the dashboard
      </Link>
    </main>
  );
}
